import React from 'react';
import { TextLight } from 'components/Texts';
import {
  colors, weight, Div, Figure,
} from 'globalStyle';
import { routes } from 'routes';
import { useLocation } from 'wouter';
import { getContrastTextColor } from 'util/contrast';
import { hasDaysLeft } from 'util/calculateDifferenceBetweenDates';
import { capitalizeFirstLetterString } from 'util/capitalizeFirstLetter';
import { getCategoryProject } from 'util/getCategoryProject';
import { formatNumber } from 'util/formatNumber';
import { projectStateType, projectSectionsState } from 'types';
import {
  typesProjectType, colorByProjectType,
} from 'types/projectType';

import {
  Card,
  CategoryContainer,
  ContainerDetails,
  Content,
  Details,
  ImgContainer,
  NameContainer,
  StatusProject,
  TextName,
  TypeProject,
} from './stylesProjectCard';
import StyledHollow from './StyledHollow';

export const statusProjectsFinanced = [
  'PRE_MONEY_GIVE',
  'PENDING_BOND',
  'MONEY_GIVE',
  'PENDING_PAYMENT',
  'PENDING_EXCEL',
  'ARREARS',
];

export const GenericProjectCard = ({
  projectName,
  companyName,
  category,
  from,
  tag,
  currencyIso,
  currentAmount,
  images,
  status,
  endDate,
  details,
  maxAmount,
  color: customColor,
  projectType,
}) => {
  const [, setLocation] = useLocation();
  const { imageCategory } = getCategoryProject(
    category, customColor || colorByProjectType[projectType],
  );
  const projectStatus = projectStateType[status];

  const handleClick = () => {
    setLocation(`${routes.project.route}${tag}${from ? `?from=${from}` : ''}`);
  };

  const lengthDetails = details.length;
  const widthDetail = `calc(100% / ${lengthDetails})`;

  const ProjectDetails = () => (
    <ContainerDetails>
      {details?.map(({ name, value, size }) => (
        <Details key={name} width={widthDetail}>
          <TextLight
            size={11}
            isCenter
            weight={weight.MEDIUM}
            color={colors.GRAY_3}
            height="40%"
          >
            {name}
          </TextLight>

          <TextLight
            size={size || 14}
            weight={weight.BOLD}
            isCenter
            height="40%"
          >
            {value}
          </TextLight>
        </Details>
      ))}
    </ContainerDetails>
  );

  const HandleButtons = () => (
    <Div
      isFlex
      justify={status === 'OPEN' && hasDaysLeft(endDate) && 'space-around'}
    >
      {status === 'OPEN' && hasDaysLeft(endDate) && (
        <StyledHollow
          href={`${routes.project.route}${tag}`}
          style={{
            width: '100px',
            height: '35px',
            padding: '10px 0',
            borderRadius: '20px',
          }}
          size={12}
          customColor={customColor || colorByProjectType[projectType]}
          textColor={getContrastTextColor(customColor || colorByProjectType[projectType])}
        >
          Invertir
        </StyledHollow>
      )}
      <StyledHollow
        href={`${routes.project.route}${tag}`}
        color={colorByProjectType[projectType]}
        style={{
          width: '100px',
          height: '35px',
          padding: '10px 0',
          borderRadius: '20px',
        }}
        size={12}
        borderColor={customColor}
        customColor={customColor ? colors.WHITE : undefined}
        textColor={
          getContrastTextColor(
            customColor || colorByProjectType[projectType],
            { defaultDark: customColor || colorByProjectType[projectType] },
          )
        }
      >
        Más detalles
      </StyledHollow>
    </Div>
  );

  return (
    <Card onClick={handleClick}>
      <ImgContainer>
        <StatusProject>
          <TextLight
            size={13}
            color={customColor || colorByProjectType[projectType]}
            weight={weight.BOLD}
            style={{ fontStyle: 'italic' }}
          >
            {`${
              projectStatus === 'OPEN' && !hasDaysLeft(endDate)
                ? 'Proyecto no disponible'
                : `${capitalizeFirstLetterString(
                  projectSectionsState[projectStatus],
                )}`
            }`}
          </TextLight>
        </StatusProject>
        <TypeProject>
          {typesProjectType[projectType]}
        </TypeProject>

        <Div
          style={{
            width: '100%',
            height: '100%',
            backgroundImage: `url(${images[0]})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            borderRadius: '25px 25px 0 0',
          }}
        />

        <NameContainer
          finalCustomColor={`${customColor || colorByProjectType[projectType]}78`}
          initialCustomColor={`${customColor || colorByProjectType[projectType]}8A`}
        >
          <TextName clamp={2} fontWeight={weight.BOLD}>
            {capitalizeFirstLetterString(projectName)}
          </TextName>
          <TextName clamp={1} fontWeight={weight.MEDIUM} margin="5px 0 0">
            {`Por ${capitalizeFirstLetterString(companyName)}`}
          </TextName>
          <CategoryContainer>
            <Figure
              style={{
                width: '60%',
                height: '60%',
                position: 'relative',
                top: '8px',
                left: '8px',
              }}
            >
              {imageCategory}
            </Figure>
          </CategoryContainer>
        </NameContainer>
      </ImgContainer>
      <Content>
        <Div>
          <TextLight size={13}>
            Monto recaudado:
            <span style={{ fontWeight: weight.BOLD, marginLeft: '3px' }}>
              {formatNumber(currentAmount, null, currencyIso)}
            </span>
          </TextLight>
          <TextLight size={13}>
            Meta:
            <span style={{ fontWeight: weight.BOLD, marginLeft: '3px' }}>
              {formatNumber(maxAmount, null, currencyIso)}
            </span>
          </TextLight>
        </Div>
        <ProjectDetails />
        <HandleButtons />
      </Content>
    </Card>
  );
};
